export default __webpack_public_path__ + "static/media/home-architecture-slider-03.25d65c49.jpg";